import { render, staticRenderFns } from "./WhiteItem.vue?vue&type=template&id=05d43c71&scoped=true"
import script from "./WhiteItem.vue?vue&type=script&lang=js"
export * from "./WhiteItem.vue?vue&type=script&lang=js"
import style0 from "./WhiteItem.vue?vue&type=style&index=0&id=05d43c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d43c71",
  null
  
)

export default component.exports